/**
 * Created by tomers on 5/31/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");

    var UserListLayout = require("user-management-views/users/UserListLayout");
    var UsersGridView = require("user-management-views/users/UsersGridView");
    var UsersWithProfilesGridView = require("user-management-views/users/UsersWithProfilesGridView");
    var UsersGridModel = require("user-management-models/UsersGridModel");
    var UserListComparators = require("user-management-comparators/UserListComparators");
    var UserManagementUtilities = require("user-management-utils/UserManagementUtilities");
    var SecureUtilities = require("infra-util/SecureUtilities");

    var UsersFilters = require("user-management-filters/UsersFilters");
    var CONST = require("const");
    var DEFAULT_COMPARATOR = function(model){
        return model.getDisplayName();
    };
    var DEFAULT_ORDERBY = "asc";
    var PAGE_SIZE = 25;

    var UserListController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserListController = Marionette.Controller.extend({
            searchStringValue: "",
            dataInitialized: false,
            viewInitialized: false,

            initialize: function (options) {
                this._initialize(options);
            },

            getView: function (options) {
                return this._getView(options);
            },
            onNavigateOut: function(){
                this._onNavigateOut();
            },

            _initialize: function (options) {
                LEUserManagement.logger.debug("_initialize", "UserListController:_initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_LIST);
                this.usersGridModel = new UsersGridModel();
                this._bindEventsChannel();
            },

            _bindEventsChannel: function() {
                LEUserManagement.logger.debug("_bindEventsChannel", "UserListController:_bindEventsChannel");
                this.listenTo(this.channel, "paging:change", this._onPagingChange);
                this.listenTo(this.channel, "row:selector:click", this._onRowSelectorClick);
                this.listenTo(this.channel, "row:click", this._onRowClick);
                this.listenTo(this.channel, "actionMenu:select", this._onActionMenuSelect);
                this.listenTo(this.channel, "search:initiate", this._onSearchRequest);
                this.listenTo(this.channel, "search:updateValue", this._updateSearchString);
                this.listenTo(LEUserManagement.getDataManager().getPermissionGroupsCollection(), "fetch:success", this._updatePermissionGroups);
            },

            _getView: function(options) {
                LEUserManagement.logger.debug("_getView", "UserListController:_getView");
                this._unbindEventsDataAndViews();
                this._initData(options);
                this._initViews();
                this._bindEventsDataAndViews();
                return this.userListLayout;
            },

            _initData: function(options) {
                LEUserManagement.logger.debug("_initData", "UserListController:_initData");
                if (!this.dataInitialized) {
                    LEUserManagement.logger.debug("_initData - initializing all data once", "UserListController:_initData");
                    this._updatePermissionGroups();

                    var usersCollection = LEUserManagement.getDataManager().getUsersCollection();
                    usersCollection = SelectableCollectionDecorator.decorate(usersCollection);
                    this.usersOrganizedCollection = OrganizeCollectionDecorator.decorate(usersCollection, {
                        comparator: DEFAULT_COMPARATOR,
                        orderBy: DEFAULT_ORDERBY,
                        pageSize: PAGE_SIZE,
                        lazy: true
                    });

                    this.usersOrganizedCollection.reset(); //start the table collection empty until the first organize call, do not worry original is still full.

                    this.agentGroupsCollection = LEUserManagement.getDataManager().getAgentGroupsCollection();
                    this.settingsCollection = LEUserManagement.getDataManager().getSiteSettingsUserList();
                    this.dataInitialized = true;
                }

            },

            _initViews: function() {
                LEUserManagement.logger.debug("_initViews", "UserListController:_initViews");
                if (!this.viewInitialized) {
                    LEUserManagement.logger.debug("_initData - initializing all views once", "UserListController:_initViews");
                    var acUsersAccount = LE.siteSettings.accountSettings.isAcUser();
                    var exportAcUsersData = UserManagementUtilities.hasExportAcUsersData();

                    this.userListLayout = new UserListLayout({
                        displayAcUsersExport: (exportAcUsersData && acUsersAccount),
                        searchStringValue: this.searchStringValue,
                        usersCollection: this.usersOrganizedCollection
                    });

                    if (LE.sessionManager.hasProfilesFeature()) {
                        this.usersGridView = new UsersWithProfilesGridView({
                            collection: this.usersOrganizedCollection,
                            settingsCollection: this.settingsCollection,
                            model: this.usersGridModel,
                            filters: UsersFilters,
                            comparators: UserListComparators,
                            isShowLoader: true,
                            textLoader: {
                                filtering: UsersWithProfilesGridView.LOADER_TEXT.FILTERING,
                                sorting: UsersWithProfilesGridView.LOADER_TEXT.SORTING
                            },
                            isShowAnimation: false
                        });
                    }
                    else {
                        this.usersGridView = new UsersGridView({
                            collection: this.usersOrganizedCollection,
                            settingsCollection: this.settingsCollection,
                            model: this.usersGridModel,
                            filters: UsersFilters,
                            comparators: UserListComparators,
                            isShowLoader: true,
                            textLoader: {
                                filtering: UsersGridView.LOADER_TEXT.FILTERING,
                                sorting: UsersGridView.LOADER_TEXT.SORTING
                            },
                            isShowAnimation: false
                        });
                    }

                    this.viewInitialized = true;
                }

                this.usersGridView.setGroupsColumnVisibility(this._isGroupColumnVisible());
            },

            _bindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_bindEventsDataAndViews", "UserListController:_bindEventsDataAndViews");
                this.listenTo(this.userListLayout, "render", this._onLayoutRender);
                this.listenTo(this.userListLayout, "show", this._onLayoutShown);  //listen to show not render ( we are using region add - this will trigger every time the view is seen )
                this.listenTo(this.userListLayout, "close", this._onLayoutClose);

                this.listenTo(this.usersOrganizedCollection ,"reset", this._onCollectionReset);
                this.usersOrganizedCollection.bindToOriginalCollectionEvents();
            },

            _isGroupColumnVisible: function() {
                LEUserManagement.logger.debug("_isGroupColumnVisible", "UserListController:_isGroupColumnVisible");

                var isAcUser = LE.siteSettings.accountSettings.isAcUser();
                var hasGroupStructure = this.agentGroupsCollection.length > 1;
                var hasAgentGroupSettings = LE.sessionManager.hasAgentGroupsFeature();

                return (hasGroupStructure && isAcUser && hasAgentGroupSettings);

            },

            //happens once
            _onLayoutRender: function() {
                LEUserManagement.logger.debug("_onLayoutRender", "UserListController:_onLayoutRender");
                this.userListLayout.gridRegion.show(this.usersGridView);
            },

            //happens every time
            _onLayoutShown: function() {
                LEUserManagement.logger.debug("_onLayoutShown", "UserListController:_onLayoutShown");
                this.usersOrganizedCollection.organize({filterModel:this.usersGridModel});
                this._showMigrationDoneMessage();
            },

            _showMigrationDoneMessage: function() {
                LEUserManagement.logger.debug("_showMigrationDoneMessage", "UserListController:_showMigrationDoneMessage");
                if (LE.context.get("migrationDone")) {
                    LE.context.set("migrationDone", null);
                    LEUserManagement.notifier.showSuccess(LE.translator.translate("LEFramework.upgrade.changed.permissions"));
                }
            },

            _onCollectionReset: function(collection, options) {
                this._handleActionMenu();
            },

            _onPagingChange: function(currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange", "UserListController:_onPagingChange");
                this.showTableLoader({textLoader: UsersGridView.LOADER_TEXT.LOADING, isShowAnimation: false});
                setTimeout(_.bind( function() {
                    this.usersOrganizedCollection.organize({currentPage:currentPageNumber});
                    this.closeTableLoader();
                }, this), 200);
            },

            _onRowSelectorClick: function(options) {
                LEUserManagement.logger.debug("_onRowSelectorClick", "UserListController:_onRowSelectorClick");
                var itemModel = options.itemModel;
                var isChecked = options.isChecked;

                if (isChecked) {
                    var currentSelectedModel = this.usersOrganizedCollection.getSelectedModel();
                    if (!_.isEmpty(currentSelectedModel)) {
                        currentSelectedModel.trigger("model:selection:change", false);
                    }
                    this.usersOrganizedCollection.addToSelection(itemModel, {exclusively:true});
                }
                else {
                    this.usersOrganizedCollection.deselectModel(itemModel);
                }
                itemModel.trigger("model:selection:change", isChecked);

                this._handleActionMenu();
            },

            _onRowClick: function(userModel) {
                LEUserManagement.logger.debug("_onRowClick", "UserListController:_onRowClick");
                this._navigateToUser(userModel.id);
            },

            _handleActionMenu: function() {
                LEUserManagement.logger.debug("_handleActionMenu", "UserListController:_handleActionMenu");

                var selectedModel = this.usersOrganizedCollection.getSelectedModel();
                var hasSelectedModel = !_.isEmpty(selectedModel);
                var isExportAcUsersData = UserManagementUtilities.hasExportAcUsersData();

                if (isExportAcUsersData) {
                    this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.EXPORT, enabled: true});
                }
                this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.EDIT, enabled: hasSelectedModel});
                this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.DELETE, enabled: hasSelectedModel});
            },

            _onActionMenuSelect: function(selectedItemId) {
                LEUserManagement.logger.debug("_onActionMenuSelect "+ selectedItemId, "UserListController:_onActionMenuSelect");
                switch (selectedItemId) {
                    case UserListLayout.ACTION_MENU_ITEMS.ADD:
                        this._onAddSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.EDIT:
                        this._onEditSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.DELETE:
                        this._onDeleteSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.EXPORT:
                        this._exportAllList();
                        break;
                }
            },

            _onAddSelected: function() {
                LEUserManagement.logger.debug("_onAddSelected ", "UserListController:_onAddSelected");
                this._navigateToUser(CONST.ROUTING.NEW_ITEM_ID);
            },

            _onEditSelected: function() {
                LEUserManagement.logger.debug("_onEditSelected ", "UserListController:_onEditSelected");
                var selectedModel = this.usersOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._navigateToUser(selectedModel.id);
                }
            },

            _onDeleteSelected: function() {
                LEUserManagement.logger.debug("_onDeleteSelected ", "UserListController:_onDeleteSelected");
                var selectedModel = this.usersOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    var message = LE.translator.translate({
                        key: "LEUserManagement.userList.delete.confirm.text",
                        args: [{key: SecureUtilities.escapeForHtmlContent(selectedModel.getLoginName()), isTranslate:false}]
                    });

                    LEUserManagement.notifier.showConfirm({
                        title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                        content: message,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.delete"),
                            callback: _.bind(this._onDeleteConfirmed, this)
                        }
                    });
                }
            },

            _onDeleteConfirmed: function() {
                LEUserManagement.logger.debug("_onDeleteConfirmed ", "UserListController:_onDeleteConfirmed");
                var selectedModel = this.usersOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    LEUserManagement.showLoader();
                    selectedModel.destroy({
                        success: _.bind(this._onDeleteSuccess, this),
                        error: _.bind(this._onDeleteError, this),
                        wait: true
                    });
                }
            },

            _onDeleteSuccess: function(model, resp, options) {
                LEUserManagement.logger.debug("_onDeleteSuccess ", "UserListController:_onDeleteSuccess");
                this._onSearchDeleting();
                LEUserManagement.closeLoader();
                this.usersOrganizedCollection.clearSelection();
            },

            _onSearchDeleting: function () {
                LEUserManagement.logger.debug("_onSearchDeleting ", "UserListController:_onSearchDeleting");
                if(this.searchStringValue){
                    this._onSearchRequest({value: this.searchStringValue});
                }
            },

            _onDeleteError: function(model, resp, options) {
                LEUserManagement.logger.info("_onDeleteError ", "UserListController:_onDeleteError",resp);
                LEUserManagement.closeLoader();

                var errorMessage = LE.translator.translate("LEFramework.something.went.wrong");
                if (resp && resp.responseError && resp.responseError.error && resp.responseError.error.message) {
                    errorMessage = resp.responseError.error.message;

                    if (_.include(resp.responseError.error.message, ErrorCodes.appServer.messages.currentLoggedInUser)) {
                        errorMessage = LE.translator.translate("LEFramework.userList.delete.error.currentLoggedInUser");
                    }
                }

                LEUserManagement.notifier.showError(errorMessage);
            },

            _exportAllList: function() {
                LEUserManagement.logger.debug("_exportAllList ", "UserListController:_exportAllList");
                UserManagementUtilities.exportAllList();
            },


            _onLayoutClose: function() {
                LEUserManagement.logger.debug("_onLayoutClose ", "UserListController:_onLayoutClose");
                this._unbindEventsDataAndViews();
            },

            _updateSearchString: function(searchObj) {
               this.searchStringValue = searchObj.value;
            },

            _updatePermissionGroups: function () {
                var permissionGroupsCollection = LEUserManagement.getDataManager().getPermissionGroupsCollection();
                if (permissionGroupsCollection) {
                    this.usersGridModel.setPermissionGroups(permissionGroupsCollection);
                }
            },

            _onSearchRequest: function(searchObj) {
                LEUserManagement.logger.debug("_onSearchRequest ", "UserListController:_onSearchRequest");
                var previousSearchValue = this.usersGridModel.getSearchString();
                var currentSearchValue = this._getSearchValue(searchObj);
                if (previousSearchValue !== currentSearchValue){
                    this.showTableLoader({textLoader: UsersGridView.LOADER_TEXT.SEARCHING, isShowAnimation: false});
                    setTimeout(_.bind( function() {
                        this.usersGridModel.setSearchString(currentSearchValue);
                        this.closeTableLoader();
                    }, this), 200);
                }
            },

            _getSearchValue: function(searchObj){
                return (searchObj && searchObj.value) ? searchObj.value : "";
            },

            _unbindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_unbindEventsDataAndViews ", "UserListController:_unbindEventsDataAndViews");
                if (this.userListLayout) {
                    this.stopListening(this.userListLayout);
                }
                if (this.usersOrganizedCollection) {
                    this.stopListening(this.usersOrganizedCollection);
                    this.usersOrganizedCollection.unBindFromOriginalCollectionEvents();
                }

            },

            _onNavigateOut: function(){
                this._unbindEventsDataAndViews();
            },

            _navigateToUser: function(userId) {
                LEUserManagement.logger.debug("_navigateToUser " + userId, "UserListController:_navigateToUser");
                LEUserManagement.router.navigate("users/"+userId);
            },

            showTableLoader: function(options) {
                LEUserManagement.logger.debug("showTableLoader ", "UserListController:showTableLoader");
                this.usersGridView.showLoader(options);
            },

            closeTableLoader: function() {
                LEUserManagement.logger.debug("closeTableLoader ", "UserListController:closeTableLoader");
                this.usersGridView.closeLoader();
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserListController;
});

